
  Vue.component('abb-menu-header', {
    props: {
      pageStyle: { type: String, default: '-1' },
      extraStyle: { type: String },
      title: { type: String, default: 'TITOLONE' },
      subTitle: { type: String, default: 'SOTTO TITOLO' },
      titleIcon: { type: String, default: 'fa-circle' },
      titleImage: { type: String }
    },
    data() {
      return {}
    },
    template: '#abb-menu-header',
    computed: {
      hasDefaultSlot() {
        return !!this.$slots.default
      }
    },
    watch: {},
    methods: {},
    mounted() {}
  })
